import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js'
  
export const commonPhotoSwipe = {
  mounted() {
    if (!this.lightbox) {
      this.lightbox = new PhotoSwipeLightbox({
        gallery: '.photoswipe',
        children: 'a',
        pswpModule: () => import('photoswipe/dist/photoswipe.esm.js'),
      });
      this.lightbox.init();
    }
  },
  unmounted() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  },
}